module.exports = __webpack_public_path__ + "img/cx.7ce715e7.svg";